import api from "api";
import { apiHeaderOptions } from "./apiHeaderOptions";

const fetchDropdownValues = async (id: string) => {
  const url = api.config.getDropDownValues(id);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};
const pubmedIdValidation = async (id: string) => {
  const url = api.config.pubMedIdSearch(id);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

export const singleUploadService = {
  fetchDropdownValues,
  pubmedIdValidation
};
